import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./theme";
import { GlobalStyle } from "./theme/GlobalStyle";
import { SkeletonTheme } from "react-loading-skeleton";
import { routes } from "./routes";

type themeType = typeof lightTheme;

function App() {
  // Session hydration lives in AuthProvider's useState initialiser, so it happens
  // before the first render rather than in an effect after it

  //Disable scroll that changes number values app wide
  // @ts-ignore
  document.addEventListener("wheel", function (event) {
    try {
      if (
        (document.activeElement as HTMLInputElement)?.type === "number" &&
        !document.activeElement?.classList?.contains("noscroll")
      ) {
        (document.activeElement as HTMLElement)?.blur();
      }
    } catch (e: any) {
      console.log(e.message);
    }
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <GlobalStyle />
        <RouterProvider router={routes} />
      </SkeletonTheme>
    </ThemeProvider>
  );
}

export type { themeType };
export default App;
